import store from '../../../index';

export default {
    namespaced: true,
    state: {
        currentViewer3d: {},
        defaultViewer3d: {
            file: {
                path: '',
                name: ''
            },
            background: {
                path: '',
                name: ''
            },
            coordinate: ['0', '0'],
            scale: '100'
        }
    },

    getters: {
        defaultViewer3d: (state) => {
            return state.defaultViewer3d;
        }
    },

    mutations: {
        SET_DATA: (state, data) => {
            state.currentViewer3d = Object.assign({}, state.currentViewer3d, data);
        },
        SET_DATA_COORDINATE: (state, data) => {
            state.currentViewer3d.coordinate[data.index] = data.value;
        },
        CLEAN_CURRENT_DATA: (state) => {
            state.currentViewer3d = {};
        }
    },

    actions: {
        viewer3dUpdate: function (localStore) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.currentViewer3d };
                store.dispatch('actions/updateActionData', value).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        }
    }
};
